module.exports = __webpack_public_path__ + "img/Middle.29f3cc9e.svg";